export default __webpack_public_path__ + "static/media/Japan_Particle_0000_Aku_Claw.60d595ab.png";